export default __webpack_public_path__ + "static/media/cloud.537bf324.svg";